export default "__VITE_PUBLIC_ASSET__c3fd4e41__"